import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from '@pletly/feature-auth';

import { useGetRole } from '../../../../../helpers/useGetRole';
import { OrganisationRole } from '../../../../../__generated__/types';
import { OrganisationMemberDataType } from '../../OrganisationMembersTable';
import { RoleMenu, RoleMenuOption } from '../../../../components/MembersTable/RoleMenuCell';

type RoleCellProps = {
	row: OrganisationMemberDataType;
	onRoleChange: (memberId: string, role: OrganisationRole) => void;
};

export const OrganisationRoleCell = ({ row, onRoleChange }: RoleCellProps) => {
	const { t } = useTranslation();
	const { getRoleString } = useGetRole();
	const user = useUser();

	const options: RoleMenuOption<OrganisationRole>[] = useMemo(
		() => [
			{
				title: t('roles.manager'),
				value: OrganisationRole.Manager,
			},
			{ title: t('roles.member'), value: OrganisationRole.Member },
		],
		[t],
	);

	const currentOption = useMemo(
		() => ({
			title: getRoleString(row.role, row.organisationRole),
			value: row.organisationRole,
		}),
		[getRoleString, row.role, row.organisationRole],
	);

	return (
		<RoleMenu
			options={options}
			currentOption={currentOption}
			onRoleChange={(value) => onRoleChange(row.memberId, value)}
			disabled={row.id === user?.id}
		/>
	);
};
